enum CoverageStatus {
  Covered = '✓',
  NotApplicable = 'N/A',
  Sponsored = 'X-TEAM SPONSORED',
}

interface CoverageBadgeProps {
  value: CoverageStatus;
  isMobile?: boolean;
}

function CoverageBadge({ value, isMobile = false }: CoverageBadgeProps) {
  if (value === CoverageStatus.Covered) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full bg-green-100 font-bold text-green-700 ${
          isMobile ? 'h-6 w-6 text-xs' : 'h-7 w-7 text-xs lg:h-8 lg:w-8 lg:text-sm'
        }`}
      >
        {CoverageStatus.Covered}
      </span>
    );
  }
  if (value === CoverageStatus.NotApplicable) {
    return (
      <span
        className={`inline-block rounded-full bg-gray-100 font-semibold text-gray-500 ${
          isMobile ? 'px-2 py-0.5 text-xs' : 'px-2 py-0.5 text-[10px] lg:px-3 lg:py-1 lg:text-xs'
        }`}
      >
        {CoverageStatus.NotApplicable}
      </span>
    );
  }
  return (
    <span
      className={`inline-block rounded-full bg-red-100 font-bold whitespace-nowrap text-red-700 ${
        isMobile ? 'px-2 py-0.5 text-xs' : 'px-2 py-0.5 text-[10px] lg:px-3 lg:py-1 lg:text-xs'
      }`}
    >
      {value}
    </span>
  );
}

export { CoverageBadge, CoverageStatus };
